import styled from "styled-components";
import BckImage from "../../assets/images/Tela_fundo_privacidade2.svg";
import { Button, Text } from "@gcs/design-system/react";

export const Background = styled.div(({ theme, desktop }) => ({
  background: `${
    desktop ? "no-repeat" : "linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)),"
  } url(${BckImage})`,
  backgroundSize: "cover",
  height: "90vh",
  minHeight: "500px",
  display: "flex",
  flexDirection: "column",
  backgroundPositionX: "center",

  [theme.breakpoint.lg()]: {
    display: "flex",
  },
}));

export const Container = styled.div(({ theme }) => ({
  width: "90%",
  height: "600px",
  display: "flex",
  justifyContent: "space-evenly",
  alignItems: "center",
  flexDirection: "column",
  paddingLeft: "36px",
  marginTop: "24px",
  [theme.breakpoint.lg()]: {
    alignItems: "flex-start",
    padding: "2% 5%",
    // justifyContent: "flex-spa",
    gap: "24px",
  },
}));

export const Title = styled(Text).attrs({ variant: "headline-03" })(
  ({ theme, desktop }) => ({
    fontSize: desktop ? "39px" : "27px !important",
    fontFamily: "CAIXA Std !important",
    fontWeigth: "700",
    textAlign: "center !important",
    color: "white !important",
    width: "85%",
    paddingTop: "50px",
    [theme.breakpoint.lg()]: {
      fontSize: "59px",
      textAlign: "left !important",
      width: "40%",
      minWidth: "335px",
    },
  })
);

export const Subtitle = styled(Text).attrs({ variant: "body02-sm" })(
  ({ theme }) => ({
    color: "white !important",
    width: "80%",
    fontSize: "23px",
    textAlign: "center !important",
    [theme.breakpoint.lg()]: {
      textAlign: "left !important",
      width: "40%",
    },
  })
);

export const ButtonStyled = styled(Button)(() => ({
  maxWidth: "240px",
  borderRadius: "4px !important",
}));
